const AnalyticsEvents = {
  MODEL_VIEW: 'model_view',
};

export default AnalyticsEvents;
